var path = '/src/app.html';
var html = "<div ui-view=\"header\"></div>\n<div ui-view=\"main\"></div>\n<div id=\"footer\" style=\"z-index:-1\">\n  <div class=\"poweredBy\">\n    <p>Powered by Eventix</p>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;